import React, { useEffect, useState } from 'react'
import Cookies from 'universal-cookie';
import toast from 'react-hot-toast';
import Modal from 'react-bootstrap/Modal';
import Table from 'react-bootstrap/Table';

import { getAdminDetails, getOrgById } from '../../services';

export const UserDetails = () => {
    const [userDetails, setUserDetails] = useState('');
    const [orgDetails, setOrgDetails] = useState('');
    const [showUserDetails, setShowUserDetails] = useState(false);

    const toggleUserDetails = () => setShowUserDetails(prev => !prev)

    
    useEffect(() => {
        let loginData1 = new Cookies().get('loginData1');
        let id = loginData1?.recordId;
        let orgId = loginData1?.organisationId;

        getAdminDetails(id).then((res) => {
            if (res.errorCode === 0) {
                let d = res.responsePacket;
                setUserDetails(d);
                localStorage.setItem('userDetail', JSON.stringify(d));
            }
        });

        getOrgById(orgId).then((res) => {
            if (res.errorCode === 0) {
                let d = res.responsePacket;
                localStorage.setItem('orgDetail', JSON.stringify(d));
                setOrgDetails(d);
            } else {
                toast(res.message);
            }
        });

    }, [])

    return (
        <>
            <div className='user-account d-flex cursor-pointer' onClick={toggleUserDetails}>
                <div className='user_div mr-2'>
                    <img src='https://etouch.s3.ap-south-1.amazonaws.com/primary-image/user.png' className='user-photo' alt='User Profile Picture' />
                </div>
                <div>
                    <div> Welcome</div>
                    <div>{userDetails && userDetails.fullName}</div>
                </div>
            </div>

            {
                showUserDetails && <Modal show={showUserDetails} onHide={toggleUserDetails}>
                    <Modal.Body>
                        <h1 className='font-weight-bold'>User Details</h1>
                          <table>
                            <tbody>
                                <tr>
                                    <td>Name:</td>
                                    <td>{userDetails.fullName}</td>
                                </tr>
                                <tr>
                                    <td>UserName:</td>
                                    <td>{userDetails.username}</td>
                                </tr>
                                <tr>
                                    <td>Phone:</td>
                                    <td>{userDetails.mobile}</td>
                                </tr>
                                <tr>
                                    <td>User Type:</td>
                                    <td>{userDetails.userType}</td>
                                </tr>
                                <tr>
                                    <td>Org:</td>
                                    <td>
                                        {userDetails?.organisationTitle}&nbsp;, {orgDetails?.beanAddress?.state}
                                    </td>
                                </tr>
                                <tr>
                                    <td>GSTIN:</td>
                                    <td>{orgDetails?.gstNumber}</td>
                                </tr>

                                <tr>
                                    <td>Warehouse:</td>
                                    <td>
                                        {userDetails &&
                                            userDetails?.beanUserWarehouseList?.map((a, i) => {
                                                return <span key={i}>{a.warehouseTitle},&nbsp;</span>;
                                            })}
                                    </td>
                                </tr>
                            </tbody>
                            </table>
                    </Modal.Body>
                </Modal>
            }
        </>

    )
}

export default UserDetails
